import { render, staticRenderFns } from "./Pluggy.vue?vue&type=template&id=e7653e5e&scoped=true&"
import script from "./Pluggy.vue?vue&type=script&lang=js&"
export * from "./Pluggy.vue?vue&type=script&lang=js&"
import style0 from "./Pluggy.vue?vue&type=style&index=0&id=e7653e5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7653e5e",
  null
  
)

export default component.exports